module.exports = __webpack_public_path__ + "static/media/05_crisalide.1fcb3fd8.jpg";